const moment = require('moment');

module.exports = function (date) {
    if (!date) {
        return null;
    }
    let localDateTime = moment.utc(date).toDate();
    return moment(localDateTime).format('MM/DD/YYYY');
};
